import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import User from "./User";

export default class Users extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'user',
            data: null,
            loading: true,
            configName: 'users_grid',
            moduleName: 'کاربران',
        };
    }
    componentDidMount() {
        this.refreshData();
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "fullName", caption: "نام", show: true },
                { field: "roleString", caption: "نقش", show: true },
                { field: "statusString", caption: "وضعیت", show: false },
                { field: "mobile", caption: "موبایل", show: true },
                { field: "createDatePersian", caption: "تاریخ ثبت", show: true },
                { field: "editDatePersian", caption: "تاریخ بروزرسانی", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'fullName' && f.show) t.push({ field: f.field, flex: 2, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.fullName}</a> } });
            if (f.field == 'roleString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'statusString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'mobile' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDatePersian' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDatePersian' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    onEdit(id) {
        this.showComponents({ component: <User Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <User Caller={this} /> });
    }
    renderForm() {
        return <div className="nk-content-body">
            <div className="nk-block">
                <div className="card card-bordered card-stretch">
                    <div className="card-inner-group">
                        <div className="card-inner p-0">
                            {this.getToolBar()}
                            {this.renderAgGrid({
                                columnDefs: this.getColumns()
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}